var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-button",class:{
    'dropdown-button_active': _vm.value
  },on:{"click":_vm.toggleDropdown}},[_c('MIcon',{staticClass:"dropdown-button__icon",attrs:{"icon":_vm.iconArrow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }